const firebaseConfig = {
  apiKey: 'AIzaSyDSOVsctTecBVtnIbA6g13VyDBMMrlZrb4',
  authDomain: 're-payment-90e7a.firebaseapp.com',
  projectId: 're-payment-90e7a',
  storageBucket: 're-payment-90e7a.appspot.com',
  messagingSenderId: '150165041685',
  appId: '1:150165041685:web:364d5d30369dbc7c45d41c',
  measurementId: 'G-0QXFHBWF9W',
}

export default firebaseConfig
